import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./customizations.scss";

export default function Customizations() {
  // eslint-disable-next-line
  const [theme, setTheme] = useState(
    !localStorage.getItem("theme")
      ? localStorage.setItem("theme", "primary")
      : ""
  );
  const [customized, setCustomized] = useState(false);
  const [mode, setMode] = useState(
    localStorage.getItem("mode") === "dark" ? true : false
  );
  useEffect(() => {
    document.body.removeAttribute("class");
    document.body.classList.add(localStorage.getItem("mode"));
  });
  return (
    <>
      <div className="customizations-box">
        <div
          className="customization-icon"
          onClick={() => setCustomized(!customized)}
        >
          <i className="fal fa-cog"></i>
        </div>
        <div
          className={classNames("customization-wrapper", {
            visible: customized === true,
          })}
        >
          <h5>Themes</h5>
          <div className="theme-btns d-flex align-items-center flex-wrap">
            <button
              title="Primary"
              className={classNames("bg-primary me-1", {
                active: localStorage.getItem("theme") === "primary",
              })}
              name="theme"
              onClick={(e) => {
                setTheme({ [e.target.name]: "primary" });
                localStorage.setItem("theme", "primary");
                window.location.reload();
              }}
              style={{ width: 45, height: 45, borderRadius: "50%", border: 0 }}
            ></button>
            <button
              title="Success"
              className={classNames("bg-success me-1", {
                active: localStorage.getItem("theme") === "success",
              })}
              name="theme"
              onClick={(e) => {
                setTheme({
                  [e.target.name]: "success",
                });
                localStorage.setItem("theme", "success");
                window.location.reload();
              }}
              style={{ width: 45, height: 45, borderRadius: "50%", border: 0 }}
            ></button>
            <button
              title="Info"
              className={classNames("bg-info me-1", {
                active: localStorage.getItem("theme") === "info",
              })}
              name="theme"
              onClick={(e) => {
                setTheme({
                  [e.target.name]: "info",
                });
                localStorage.setItem("theme", "info");
                window.location.reload();
              }}
              style={{ width: 45, height: 45, borderRadius: "50%", border: 0 }}
            ></button>
            <button
              title="Warning"
              className={classNames("bg-warning me-1", {
                active: localStorage.getItem("theme") === "warning",
              })}
              name="theme"
              onClick={(e) => {
                setTheme({
                  [e.target.name]: "warning",
                });
                localStorage.setItem("theme", "warning");
                window.location.reload();
              }}
              style={{ width: 45, height: 45, borderRadius: "50%", border: 0 }}
            ></button>
            <button
              title="Danger"
              className={classNames("bg-danger", {
                active: localStorage.getItem("theme") === "danger",
              })}
              name="theme"
              onClick={(e) => {
                setTheme({
                  [e.target.name]: "danger",
                });
                localStorage.setItem("theme", "danger");
                window.location.reload();
              }}
              style={{ width: 45, height: 45, borderRadius: "50%", border: 0 }}
            ></button>
          </div>
          <h5 className="mt-3">Modes</h5>
          <div className="form-check form-switch d-flex align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexSwitchCheckDefault"
              checked={localStorage.getItem("mode") === "dark"}
              onChange={() => {
                setMode(mode === false ? true : false);
                localStorage.setItem("mode", mode === true ? "light" : "dark");
                window.location.reload();
              }}
            />
            <label
              className="form-check-label ms-2"
              htmlFor="flexSwitchCheckDefault"
            >
              {localStorage.getItem("mode") === "dark"
                ? "Disable Dark Mode"
                : "Enable Dark Mode"}
            </label>
          </div>
        </div>
      </div>
    </>
  );
}
